import api from '../../api';

const path = '/sell/all/commercial';

export const getCommercialAllRequest = (id) => api.get(`${path}/get/${id}`);
export const getCommercialAllListRequest = (params) =>
    api.get(`${path}/get`, { params });

export const getCommercialNoAccountRequest = (id) =>
    api.get(`${path}/list/get/${id}`);
export const getCommercialNoAccountListRequest = (params) =>
    api.get(`${path}/list/get`, { params });
